import { twMerge } from "tailwind-merge";
import { clsx, type ClassValue } from "clsx";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// Helper function to get the class name for folder color styling
export function getFolderColorClass(color: string = "default") {
  const folderColors = [
    {
      name: "Default",
      value: "default",
      class: "border-primary/20 bg-primary/10 text-primary",
    },
    {
      name: "Blue",
      value: "blue",
      class: "border-blue-500/20 bg-blue-500/10 text-blue-500",
    },
    {
      name: "Green",
      value: "green",
      class: "border-green-500/20 bg-green-500/10 text-green-500",
    },
    {
      name: "Yellow",
      value: "yellow",
      class: "border-yellow-500/20 bg-yellow-500/10 text-yellow-500",
    },
    {
      name: "Purple",
      value: "purple",
      class: "border-purple-500/20 bg-purple-500/10 text-purple-500",
    },
    {
      name: "Red",
      value: "red",
      class: "border-red-500/20 bg-red-500/10 text-red-500",
    },
  ];
  return (
    folderColors.find((c) => c.value === color)?.class || folderColors[0].class
  );
}

/**
 * Convert a data URL to a File object
 * @param dataUrl - The data URL to convert
 * @param filename - The filename to use for the file
 * @returns A File object that can be used for upload
 */
export function dataUrlToFile(dataUrl: string, filename: string): File {
  // Get the data part of the data URL (after the comma)
  const arr = dataUrl.split(",");
  const mime = arr[0].match(/:(.*?);/)?.[1] || "image/png";
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, { type: mime });
}

/**
 * Convert a signature data URL to a File object for storage
 * @param signatureData - JSON string containing signature data
 * @returns A File object ready for upload
 */
export function signatureToFile(signatureData: string): File | null {
  try {
    // Parse the signature info
    const signatureInfo = JSON.parse(signatureData);

    // Generate a unique filename with timestamp for uniqueness
    const timestamp = new Date().getTime();
    const filename = `signature-${signatureInfo.elementId}-${timestamp}.png`;

    // Convert data URL to file with proper name for upload
    return dataUrlToFile(signatureInfo.signatureData, filename);
  } catch (error) {
    console.error("Error converting signature to file:", error);
    return null;
  }
}
